import {
  SOCIAL_HEALTH_FLAG_HELP,
  SOCIAL_HEALTH_FLAG_LABELS,
  type SocialHealthFlag,
} from '@nova/shared';
import { cn } from '../../lib/cn.js';

/** The coloured chip classes per flag — green grows, amber is quiet, red is dead. */
const FLAG_CLASSES: Record<SocialHealthFlag, string> = {
  VOKSER: 'bg-success/12 text-success',
  FLAT: 'border border-hairline bg-raised/50 text-ink-soft',
  STILLE: 'bg-warning/12 text-warning',
  INAKTIV: 'bg-danger/12 text-danger',
};

export function SocialHealthBadge({ flag }: { flag: SocialHealthFlag }) {
  return (
    <span
      title={SOCIAL_HEALTH_FLAG_HELP[flag]}
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium',
        FLAG_CLASSES[flag],
      )}
    >
      <span
        aria-hidden
        className={cn(
          'h-1.5 w-1.5 rounded-full',
          flag === 'VOKSER' && 'bg-success',
          flag === 'FLAT' && 'bg-ink-soft',
          flag === 'STILLE' && 'bg-warning',
          flag === 'INAKTIV' && 'bg-danger',
        )}
      />
      {SOCIAL_HEALTH_FLAG_LABELS[flag]}
    </span>
  );
}
